import { Button, message } from 'antd'
import { useAccount } from 'wagmi'

import { AppAdmin } from 'api/app-admin'
import { TokenizeStatusEnum } from 'constants/pto'
import { customErrorContract } from 'hooks/contract/use-contract-viem'
import { useDeployCollection } from 'hooks/pto-v2/use-deploy-collection'
import { onCloseModalProcessing, onOpenModalProcessing } from 'stores/modal.store'
import { logError, logInfo } from 'utils/logger'

/**
 * PTO v2 - deploy the collection contract (PTOFactoryUpgradeable.deployCollection)
 * for a PTO that has been created without a contract yet.
 */
const ButtonDeployContract = ({
  id,
  onSuccess,
}: {
  id: string
  onSuccess?: () => Promise<void>
}) => {
  const { address } = useAccount()

  const { isContractManager, deployCollection } = useDeployCollection()

  const handleDeployContract = async (e: React.MouseEvent) => {
    e.preventDefault()

    try {
      if (!address) {
        message.error('Please connect wallet!')
        return
      }
      onOpenModalProcessing()
      const results = await AppAdmin.ptoGetArgs(id)
      if (results.status === 200) {
        logInfo('isContractManager----------------------------', isContractManager)
        if (isContractManager) {
          const contractAddress = await deployCollection(address, results.data.data)
          if (contractAddress) {
            await AppAdmin.ptoUpdateContract(id, {
              contractAddress,
              status: TokenizeStatusEnum.ACTIVE,
            })
            await onSuccess?.()
            onCloseModalProcessing()
            message.success('Deploy contract successfully')
          }
        } else {
          onCloseModalProcessing()
          message.error('Your wallet address does not have permission to create PTO!')
        }
      }
    } catch (error) {
      const errorMessage = customErrorContract(error)
      message.error(errorMessage || 'Error while submitting form')
      logError('error', errorMessage)
    } finally {
      onCloseModalProcessing()
    }
  }

  return address ? (
    <Button type="default" onClick={handleDeployContract} style={{ width: '100%' }}>
      Deploy Contract
    </Button>
  ) : null
}

export default ButtonDeployContract
